import moment from 'moment';
import { message } from 'antd';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import get from 'lodash/get';
import * as cronServices from '../services/cron';

const RESOURCE = 'cron';
const transfromDocument = (record) => {
	if (record.created) {
		const createdAt = record.created;
		record.created = moment.unix(createdAt);
	}
	if (record.updated_at) {
		const updatedAt = record.updated_at;
		record.updated_at = moment.unix(updatedAt);
	}

	return record;
};

export default {
  namespace: 'cron',

  state: {
    data: {
      list: [],
      pagination: {
        anchor: '',
        listAnchor: {
          1: ''
        }
      },
    },
    submitting: false,
    formTitle: '',
    formID: '',
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(cronServices.getList, payload);
        if (response) {
          if(response.cronjobs){
            list = response.cronjobs.map(item => {
              transfromDocument(item);
              return item;
            })
          }
          yield put({
            type: 'save',
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(response, ["anchor"], "")
                }
              }
            },
          });
        }
      } catch (error) {
        console.log('*fetch -> error', error);
			}
			if (callback) {
				callback(list);
			}
    },
    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: 'changeFormVisible',
        payload: true,
      });

      yield [
        put({
          type: 'saveFormType',
          payload: payload.type,
        }),
        put({
          type: 'saveFormID',
          payload: '',
        })
      ];
			if (payload.type === 'A') {
				yield [
					put({
						type: 'saveFormTitle',
						payload: 'Thêm mới',
					}),
					put({
						type: 'saveFormData',
						payload: {
							status: '1'
						},
					}),
				];
			}
      else if (payload.type === 'E') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: `Chỉnh sửa ${payload.id}`,
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'fetchForm',
            payload: {
              id: payload.id
            },
          }),
        ];
      }
      if(callback) {
        callback();
      }
    },
    *fetchForm({ payload, callback }, { call, put }) {
			let response;
			try {
				response = yield call(cronServices.get, payload.id, payload);
				if (response)
          if (response.state === 2) {
            response.state = "Kích hoạt"
          }
          if (response.state === 1) {
            response.state = "Khoá"
          }
					transfromDocument(response);
				yield [
					put({
						type: 'saveFormData',
						payload: response,
					}),
				];
			} catch (error) {
        console.log('*fetch -> error', error);
			}
			if(callback) {
        callback(response);
      }
    },
    *submit({ payload, callback }, { call, put, select }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });

      const params = { ...payload };
      const formType = yield select(state => state.cron.formType);

      let success = false;
      let response;
      try {
        if (formType === 'E') {
          const id = yield select(state => state.cron.formID);
          if(!params.id) {
              params.id = id;
            }
            params.id = +id;
          if (params.state != ""){
            params.state = +params.state;
          }
          response = yield call(cronServices.update, id, params);
          success = true;
        } else {
          if (params.state != ""){
            params.state = +params.state;
          }
          response = yield call(cronServices.create, params);
          success = true;
        }
      } catch (error) {
        success = false;
      }

      yield put({
        type: 'changeSubmitting',
        payload: false,
      });

      if (success) {
        message.success('Thành công');
        yield put({
          type: 'changeFormVisible',
          payload: false,
        });
      }
			if (callback) {
				callback(response);
			}
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ["pagination"], {});
			pagi = omit(pagi, ["listAnchor"]);
			const aPagi = get(action.payload, "pagination", {});
			const sPagi = get(state.data, "pagination", {});
			const listAnchor = Object.assign({},
				get(aPagi, "listAnchor", {}),
				get(sPagi, "listAnchor", {})
			);
			const pagination = Object.assign({},
				sPagi,
				{ listAnchor },
				pagi
			);
			return {
				...state,
				data: {
					...state.data,
					list: action.payload.list,
					pagination
				},
			};
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
